export default "__VITE_ASSET__3d993086__"